import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { withRouter } from 'next/router';
import Link from 'next/link';
import { Formik, Form } from 'formik';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { handleRegistration, openModal } from '../../redux/actions';
import SlideInModal from "../../containers/SlideInModal";
import InputList from '../InputList';
import Input from '../Input';
import { FacebookIcon, GoogleIcon } from '../../utils';

import { FormFooter, LoginButton, SignUpButton, ErrorMessage, SuccessMessage, SignupSocial, SignupSocialButton } from './styles';

const SignupSchema = Yup.object().shape({
  email: Yup.string()
    .email('Invalid email')
    .required('Email is required'),
});

const { Item } = InputList;
const { Heading, Description, Footer } = SlideInModal;

@withRouter
class SignupModal extends Component {
  static propTypes = {
    name: PropTypes.string,
    signupError: PropTypes.string,
    handleUserRegistration: PropTypes.func,
    handleLoginModalCall: PropTypes.func,
    signupSuccess: PropTypes.bool,
    router: PropTypes.instanceOf(Object),
  };

  componentDidMount() {
    window.addEventListener('message', this.onMessageHandler);
    window.addEventListener('storage', this.onStorageHandler);
  };

  componentWillUnmount() {
    window.removeEventListener('message', this.onMessageHandler);
    window.removeEventListener('storage', this.onStorageHandler);
  }

  onMessageHandler = evt => {
    if (evt.origin && evt.origin !== window.location.origin) return;

    const { data } = evt;
    const { router } = this.props;

    if (data === 'auth') {
      window.location.href = router.asPath;
    }
  };

  onStorageHandler = evt => {
    if (evt.key !== 'dayaxe-oauth-event' || !evt.newValue) return;

    const { router } = this.props;

    if (evt.newValue.indexOf('auth:') === 0) {
      window.location.href = router.asPath;
    }
  };

  render() {
    const {
      name,
      handleUserRegistration,
      signupError,
      handleLoginModalCall,
      signupSuccess,
    } = this.props;

    return (
      <SlideInModal name={name}>
        <Heading>
          Welcome to <span>Dayaxe</span>
        </Heading>
        <Description>
          Let&apos;s get you signed up. <br /> It&apos;ll take a minute.
        </Description>
        {signupSuccess ? (
          <SuccessMessage>
            A letter with password reset link has been sent to your email address
          </SuccessMessage>
        ) : (
          <Fragment>
            <SignupSocial>
              <li>
                <SignupSocialButton onClick={() => window.open(`${process.env.API_URL}users/facebook/login`, 'Sign up with Facebook', 'width=500, height=600')}>
                  <FacebookIcon />
                  Sign up with Facebook
                </SignupSocialButton>
              </li>
              <li>
                <SignupSocialButton onClick={() => window.open(`${process.env.API_URL}users/google/login`, 'Sign up with Google', 'width=500, height=600')}>
                  <GoogleIcon />
                  Sign up with Google
                </SignupSocialButton>
              </li>
            </SignupSocial>
            <Formik
              initialValues={{
                email: '',
              }}
              validationSchema={SignupSchema}
              onSubmit={values => handleUserRegistration(values)}
            >
              {({ errors, touched, handleBlur, handleChange, values }) => (
                <Form>
                  <InputList>
                    <Item>
                      <Input
                        htmlType="text"
                        name="email"
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        value={values.email}
                        hasError={errors.email && touched.email}
                        placeholder={errors.email || 'Enter email'}
                        floatingPlaceholder
                      />
                    </Item>
                  </InputList>
                  {signupError && <ErrorMessage>{signupError}</ErrorMessage>}
                  <FormFooter>
                    <LoginButton type="submit" btnType="primary">
                      Sign Up
                    </LoginButton>
                    <SignUpButton type="button" onClick={() => handleLoginModalCall('login')}>
                      Login
                    </SignUpButton>
                  </FormFooter>
                </Form>
              )}
            </Formik>
          </Fragment>
        )}
        <Footer>
          By signing up, you agree to DayAxe&apos;s <br />
          <Link href="/terms">
            <a target="_blank" rel="noopener noreferrer">Terms and Conditions</a>
          </Link>
          {' '}&{' '}
          <Link href="/privacy-policy">
            <a target="_blank" rel="noopener noreferrer">Privacy Policy</a>
          </Link>
        </Footer>
      </SlideInModal>
    )
  }
}

const mapStateToProps = state => ({
  signupSuccess: state.user.success.signup,
  signupError: state.user.errors.signup,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      handleUserRegistration: handleRegistration,
      handleLoginModalCall: openModal,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SignupModal);
